<template>
  <div class="card-data-comparer-container">
    <div>
      <span style="font-size: 14px; font-weight: bold" class="primary--text">
        {{ item.name }}
      </span>
    </div>
    <div>
      <span style="font-size: 56px; font-weight: bold" class="primary--text">
        {{ item.value }}
      </span>
    </div>
    <div>
      <span style="font-size: 28px; font-weight: bold" class="success--text">
        {{ item.percentageDifference }}
      </span>
    </div>
    <div>
      <span style="font-size: 9px; font-weight: regular" class="primary--text">
        ({{ $i18n.t("comparedToPreviousDay") }})
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Component, Vue, Prop } from "vue-property-decorator";
import { ComparedData } from "@/models/api/statistics/Statistics";

@Component
export default class CardDataComparator extends Vue {
  @Prop()
  item!: ComparedData;
}
</script>

<style lang="scss" scoped>
.card-data-comparer-container {
  text-align: center;
  border: 1px solid $container-border-color;
  border-radius: 10px;
  padding: 10px;
  margin: 10px;
  min-height: 145px;
  flex-grow: 1;
  min-width: 187px;
  background: white;
}
</style>
